<template>
  <section class="h-full w-full flex flex-col">
    <div class="h-full container mx-auto">
        <div class="px-8 flex flex-row flex-wrap w-full" v-if="$apollo.queries.selfServices.loading">
            <div class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mt-8">
              <service-tile-shimmer v-for="(item, index) in 4" :key="index"></service-tile-shimmer>
            </div>
        </div>
        <div v-else-if="!$apollo.queries.selfServices.loading && selfServices.data.length <= 0" class="h-full w-full flex flex-col justify-center items-center">
            <h1 class="text-center text-xl font-medium">No services found!</h1>
        </div>
        <div v-else class="px-8 flex flex-row flex-wrap w-full">
            <div class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mt-8">
                <service-tile v-for="(item, index) in filteredSelfServices" :key="index" :item="item"></service-tile>
            </div>
            <div class="mt-4">
                <pagination
                :paginatorInfo="paginatorInfo"
                :setPage="setPage"
                ></pagination>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import gql from 'graphql-tag';
import ServiceTileShimmer from "../../components/shared/ServiceTileShimmer.vue";
import ServiceTile from "../../components/shared/ServiceTile.vue";
import Pagination from "../../components/shared/pagination.vue";
export default {
  name: "self-services",
  components: {
      ServiceTileShimmer,
      ServiceTile,
      Pagination
  },
  data() {
    return {
      selfServices: [],
      first: 10,
      page: 1,
    };
  },
  computed: {
    role() {
      return this.$store.getters.role;
    },
    filteredSelfServices() {
        return this.selfServices.data;
    },
    paginatorInfo() {
        return this.selfServices.paginatorInfo;
    },
  },
  apollo: {
    selfServices() {
        return {
            query: gql`query GetAllSelfServices($first: Int!, $page: Int!) {
                selfServices(first: $first, page: $page) {
                    data {
                        id
                        title
                        url
                    }
                    paginatorInfo {
                        count
                        currentPage
                        firstItem
                        hasMorePages
                        lastItem
                        lastPage
                        perPage
                        total
                    }
                }
            }`,
            variables () {
                return {
                    first: this.first,
                    page: this.page,
                }
            },
            fetchPolicy: 'cache-and-network'
        }
    },
  },
  methods: {
    setPage(page) {
      this.page = page;
    },
  },
}
</script>